// extracted by mini-css-extract-plugin
module.exports = {"container":"bQ","logo":"bR","mainPanel":"bS","noActions":"bT","noOneLeftAction":"bU","noRightAction":"bV","onlyOneLeftAction":"bW"};